import React, {useState} from 'react'
import {useHistory} from 'react-router-dom'
import './Searchbar.css'

export default function Searchbar() {
    const [term,setTerm] = useState('')
    const history = useHistory()
   const onSubmitHandler = (e) =>{
        e.preventDefault()
        history.push(`/search?q=${term}`)
        setTerm('')
    }
  return (
    <div className='searchbar'>
        <form onSubmit={onSubmitHandler}>
            <label htmlFor="search">Search:</label>
            <input type="text"
            id="search"
            onChange={(e)=>setTerm(e.target.value)}
            placeholder='search'
            required
            value={term}/>
        </form>
    </div>
  )
}
